import { AbstractControl } from '@angular/forms';

export default function cpfVerdadeiro(control: AbstractControl): { [key: string]: any } | null {
    var strCPF = control.value.replace(/[.-]/g, '');
    var Soma = 0;
    var Resto;

    if (strCPF == "00000000000") return { cpfValido: true };
    if (strCPF == "11111111111") return { cpfValido: true };
    if (strCPF == "22222222222") return { cpfValido: true };
    if (strCPF == "33333333333") return { cpfValido: true };
    if (strCPF == "44444444444") return { cpfValido: true };
    if (strCPF == "55555555555") return { cpfValido: true };
    if (strCPF == "66666666666") return { cpfValido: true };
    if (strCPF == "77777777777") return { cpfValido: true };
    if (strCPF == "88888888888") return { cpfValido: true };
    if (strCPF == "99999999999") return { cpfValido: true };

    for (var i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10))) return { cpfValido: true };

    Soma = 0;
    for (var i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11))) return { cpfValido: true };
    return null;
}